export default {
  title: {
    en: 'YOUR RECOMMENDATIONS:',
  },
  thankYouTitle: {
    en: 'THANK YOU FOR REVIEW!',
  },
  subTitle: {
    en: 'Your personal recommendations:',
  },
}
